export const CUSTOMER_SERVICE = 'CUSTOMER_SERVICE';
export const CREDIT_OPERATIONS = 'CREDIT_OPERATIONS';
export const ACCOUNT_SERVICING = 'ACCOUNT_SERVICING';
export const FLEX_PAY_SUPPORT = 'FLEX_PAY_SUPPORT';
export const FLEX_PAY_SUPPORT_FR = 'FLEX_PAY_SUPPORT_FR';
export const CUSTOMER_SUPPORT = 'CUSTOMER_SUPPORT';
export const CUSTOMER_SUPPORT_ALT = 'CUSTOMER_SUPPORT_ALT';
export const PCL_CUSTOMER_SUPPORT = 'PCL_CUSTOMER_SUPPORT';
export const DEPOSIT_CUSTOMER_SUPPORT = 'DEPOSIT_CUSTOMER_SUPPORT';
export const DEPOSIT_ISSUED_CUSTOMER_SUPPORT = 'DEPOSIT_ISSUED_CUSTOMER_SUPPORT';
export const DEPOSIT_SPECIFIC_CUSTOMER_SUPPORT = 'DEPOSIT_SPECIFIC_CUSTOMER_SUPPORT';
export const DEPOSIT_CREDIT_BUILDER_VIP_SUPPORT = 'DEPOSIT_CREDIT_BUILDER_VIP_SUPPORT';
export const LOAN_SERVICING_HARDSHIP = 'LOAN_SERVICING_HARDSHIP';
export const UNIVERSAL_CREDIT_CUSTOMER_SUPPORT = 'UNIVERSAL_CREDIT_CUSTOMER_SUPPORT';
// Deprecated. Use PCL_CARD_ISSUES instead.
export const PCL_LOST_CARD = 'PCL_LOST_CARD';
export const PCL_CARD_ISSUES = 'PCL_CARD_ISSUES';
export const PCL_SERVICING = 'PCL_SERVICING';
export const HOME_IMPROVEMENT = 'HOME_IMPROVEMENT';
export const HOME_IMPROVEMENT_CUSTOMER_SUPPORT = 'HOME_IMPROVEMENT_CUSTOMER_SUPPORT';
export const HOME_IMPROVEMENT_PODS_SUPPORT = 'HOME_IMPROVEMENT_PODS_SUPPORT';
export const HOME_IMPROVEMENT_DISPUTES_SUPPORT = 'HOME_IMPROVEMENT_DISPUTES_SUPPORT';
export const DISPUTE_UPGRADE_CARD = 'DISPUTE_UPGRADE_CARD';
export const AUTO_SERVICING = 'AUTO_SERVICING';
export const AUTO_FINANCE_PRE_QUALIFICATION = 'AUTO_FINANCE_PRE_QUALIFICATION';
export const CARDS_SUPPORT_HOTLINE = 'CARDS_SUPPORT_HOTLINE';
export const DEPOSIT_CARDS_AND_ACH_TRANSFERS_DISPUTES = 'DEPOSIT_CARDS_AND_ACH_TRANSFERS_DISPUTES';
//# sourceMappingURL=departments.js.map